(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('MailingCampaignsConfigsController', mailingcampaignconfigs);

  mailingcampaignconfigs.$inject = ['FoundationApi', 'MailingConfigService', '$state', 'Upload', 'NotificationService', 'LangService', 'CompanyService'];

  function mailingcampaignconfigs (FoundationApi, MailingConfigService, $state, Upload, NotificationService, LangService, CompanyService) {
    	var vm = this;

    vm.labels = '';

    LangService
      .getPageLabels({ 'page': 'menu.config.mailingconfigs' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });

    vm.openForm = openForm;
    vm.openFieldsForm = openFieldsForm;
    vm.closeFormModal = closeFormModal;
    vm.save = save;
    vm.confirmDelete = confirmDelete;
    vm.removeConfig = removeConfig;
    vm.goToTheListing = goToTheListing;
    vm.uploadFile = uploadFile;
    vm.readFile = readFile;
    vm.loadFields = loadFields;
    vm.cleanFields = cleanFields;
    vm.getContactMetadataDefinition = getContactMetadataDefinition;
    vm.saveCmd = saveCmd;
    vm.configs = {}
    vm.editing = {};
    vm.deleting = {};
    vm.configId = {};
    vm.csvFields = {};

    loadConfigs();

    function openForm (index) {
      vm.editing = (typeof index !== 'undefined') ? vm.configs[index] : {};
      FoundationApi.publish('formModal', 'open');
    }

    function openFieldsForm (id) {
      vm.configId = id;
      loadFields();
      FoundationApi.publish('csvFieldsModal', 'open');
    }

    function closeFormModal (type) {
      if (type === 'form') {
        vm.editing = {};
        FoundationApi.publish('formModal', 'close');
      } else {
        FoundationApi.publish('csvFieldsModal', 'close');
      }
    }

    function confirmDelete (index) {
      vm.deleting = vm.configs[index];
      FoundationApi.publish('confirmDeleteModal', 'open');
    }

    function removeConfig (config) {
      MailingConfigService
        .delete({ id: config.id })
        .$promise
        .then(function (obj) {
          FoundationApi.publish('confirmDeleteModal', 'close');
          successHandler(obj, vm.labels.configRemoved);
          loadConfigs();
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorRemoveConfig);
        });
    }

    function goToTheListing () {
      $state.go('main.mailingcampaign', {});
    }

    function save () {
      if (!vm.editing.name) {
        NotificationService.warningHandler(null, vm.labels.typeName);
        return;
      }

      if (!vm.editing.format) {
        NotificationService.warningHandler(null, vm.labels.chooseFormat);
        return;
      }

      if (vm.editing.format == 'csv' && !vm.editing.delimiter) {
        NotificationService.warningHandler(null, vm.labels.typeDelimiter);
        return;
      }

      MailingConfigService
        .saveConfig(vm.editing)
        .$promise
        .then(function (result) {
          successHandler(result, vm.labels.configSaved);
          FoundationApi.publish('formModal', 'close');
          loadConfigs();
        })
        .catch(function (result) {
          errorHandler(result, vm.labels.errorSaveConfig);
        });
    }

    function loadConfigs () {
      MailingConfigService
        .getAllConfigs()
        .$promise
        .then(function (data) {
          vm.configs = data.data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadConfig);
        });
    }

    function errorHandler (data, override_message) {
      var message = vm.labels.errorTryAgain;
      if (override_message) {
        message = override_message;
      }

      if (data && data.data && data.data.message) {
        message = data.data.message;
      }

      NotificationService.warningHandler(null, message);
    }

    function successHandler (data, override_message) {
      var message = 'Os dados foram salvos com sucesso.';
      if (override_message) {
        message = override_message
      }

      if (data && data.data && data.data.message) {
        message = data.data.message;
      }

      NotificationService.successHandler(null, message);
    }

    function uploadFile (file) {
      if (file) {
        if (file.length) {
          file.upload = Upload.upload({
            url: apiUrl + '/mailing-upload-fields',
            file: file
          });

          file.upload.then(function (response) {
            successHandler(response, vm.labels.fileLoaded);
            readFile(response.data.public_path);
          }, function (response) {
            if (response.status > 0) { var message = vm.labels.errorReq; }
            if (response) {
              if (response.data) {
                if (response.data.message) { message = response.data.message; }
              }
            }
            FoundationApi.publish('main-notifications', { title: vm.labels.error, content: message, autoclose: '3000', color: 'alert' });
          });
        }
      }
    }

    function cleanFields (file) {
      MailingConfigService
        .cleanFields({
          id: vm.configId
        })
        .$promise
        .then(function (data) {
          vm.csvFields = [];
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadConfig);
        });
    }

    function loadFields () {
      MailingConfigService
        .loadFields({
          id: vm.configId
        })
        .$promise
        .then(function (data) {
          vm.csvFields = data;
          getContactMetadataDefinition();
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadConfig);
        });
    }

    function readFile (url) {
      if (url) {
        MailingConfigService
          .readFile({
            url: url,
            id: vm.configId
          })
          .$promise
          .then(function (data) {
            vm.csvFields = data;
          })
          .catch(function (error) {
            errorHandler(error, vm.labels.errorLoadConfig);
          });
      }
    }

    function getContactMetadataDefinition () {
      vm.contactMetadatas = [];
      CompanyService
        .getContactMetadataDefinition()
        .$promise
        .then(function (data) {
          vm.contactMetadatas = data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadConfig);
        });
    }

    function saveCmd (field_id, cmd_id) {
      MailingConfigService
        .saveFieldCmd({
          field_id: field_id,
          cmd_id: cmd_id
        })
        .$promise
        .then(function (data) {
          successHandler(data, vm.labels.errorLoadConfig.metadataSaved);
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorSaveMetadata);
        });
    }
  }
})();
